import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=07175cda&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"
import style0 from "./PageView.vue?vue&type=style&index=0&id=07175cda&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07175cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07175cda')) {
      api.createRecord('07175cda', component.options)
    } else {
      api.reload('07175cda', component.options)
    }
    module.hot.accept("./PageView.vue?vue&type=template&id=07175cda&scoped=true", function () {
      api.rerender('07175cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/PageView.vue"
export default component.exports